import { Home, Shield, Star, Heart } from 'lucide-react';

export const faqData = {
  english: [
    {
      question: "What is the cost of a villa?",
      answer: "The cost of a villa varies depending on its size. We have villas ranging from ₹55 lakhs to ₹75 lakhs.",
      category: "pricing",
      icon: Home
    },
    {
      question: "What are the taxes and additional costs for purchasing a villa?",
      answer: "GST, KSEB connection charges, labour welfare fund, advance monthly maintenance charges, maintenance deposits, villa registration cost and any other applicable taxes will be extra.",
      category: "pricing",
      icon: Shield
    },
    {
      question: "When is the project getting completed?",
      answer: "It is expected to take 36 months for the completion of the project.",
      category: "timeline",
      icon: Star
    },
    {
      question: "Do you have the required licences and permits?",
      answer: "Yes, we have layout permit from the DTP, Development permit from the Panchayath. The project is registered with K RERA.",
      category: "legal",
      icon: Shield
    },
    {
      question: "Will there be recurring expenses on my stay?",
      answer: "There will be monthly maintenance expenses applicable to each villa. The total expenses will be shared in proportion to the built up area of the villa.",
      category: "pricing",
      icon: Home
    },
    {
      question: "What's included in the monthly maintenance charges?",
      answer: "Common electricity bill payments, salaries of the staff, project common area and equipment maintenance expenses, applicable taxes, consumables, landscaping, swimming pool etc.",
      category: "services",
      icon: Heart
    },
    {
      question: "Can couples stay together?",
      answer: "Yes, very much. The villa is your own and it's your private property.",
      category: "living",
      icon: Heart
    },
    {
      question: "Do you offer transportation to medical appointments?",
      answer: "In case of emergency, a resident is taken to the hospital and the expenses are debited to their account.",
      category: "services",
      icon: Shield
    },
    {
      question: "What's the move-in process like?",
      answer: "Once the villa and the projects are ready and the OC is received, the villa is officially handed over to the respective owners. They can move in any time in their villas. The common amenities and services will be in place by the time the OC is received.",
      category: "timeline",
      icon: Home
    },
    {
      question: "Are the facilities charged?",
      answer: "The cost of maintaining the common facilities are maintained in the monthly maintenance charges and hence they are not charged. Expenses like laundry, food, usage of wellness centre are charged on actuals. Medical expenses, usage of car and driver are also charged on actuals.",
      category: "services",
      icon: Star
    },
    {
      question: "Is it mandatory to take meals from the dining hall?",
      answer: "No. The residents are encouraged to cook their own food if they can. The restaurant facilities are open for all meals and snacks. It is optional.",
      category: "living",
      icon: Heart
    },
    {
      question: "Can I cook myself in my villa?",
      answer: "Yes. The residents can cook their food in the villa.",
      category: "living",
      icon: Home
    },
    {
      question: "Can I rent out my villa if I do not stay there?",
      answer: "If you are not staying there in the villa, it can be rented out. We facilitate renting out of your villa if required.",
      category: "legal",
      icon: Shield
    },
    {
      question: "Is the villa registered in my name?",
      answer: "Yes, the villa is registered in favour of the respective owners along with the corresponding land area.",
      category: "legal",
      icon: Shield
    },
    {
      question: "Can I sell my villa at a later stage and will you assist in selling it?",
      answer: "As you have a freehold right in the villa, it can be sold, transferred to another person as you wish. We assist in selling the villa for you.",
      category: "legal",
      icon: Home
    }
  ],
  malayalam: [
    {
      question: "വില്ലയുടെ വില എത്രയാണ്?",
      answer: "വില്ലയുടെ വില അതിന്റെ വലുപ്പത്തിനനുസരിച്ച് വ്യത്യാസപ്പെടുന്നു. ഞങ്ങളുടെ പക്കൽ ₹55 ലക്ഷം മുതൽ ₹75 ലക്ഷം വരെയുള്ള വില്ലകൾ ഉണ്ട്.",
      category: "pricing",
      icon: Home
    },
    {
      question: "വില്ല വാങ്ങുന്നതിനുള്ള നികുതിയും അധിക ചെലവുകളും എന്തൊക്കെയാണ്?",
      answer: "GST, KSEB കണക്ഷൻ ചാർജുകൾ, തൊഴിലാളി ക്ഷേമ നിധി, അഡ്വാൻസ് പ്രതിമാസ പരിപാലന ചാർജുകൾ, പരിപാലന നിക്ഷേപം, വില്ല രജിസ്ട്രേഷൻ ചെലവ് എന്നിവയും മറ്റ് ബാധകമായ എല്ലാ നികുതികളും അധികമായി ഉണ്ടായിരിക്കും.",
      category: "pricing",
      icon: Shield
    },
    {
      question: "പദ്ധതി എപ്പോൾ പൂർത്തിയാകും?",
      answer: "പദ്ധതി പൂർത്തിയാക്കാൻ 36 മാസം എടുക്കുമെന്ന് പ്രതീക്ഷിക്കുന്നു.",
      category: "timeline",
      icon: Star
    },
    {
      question: "ആവശ്യമായ ലൈസൻസുകളും അനുമതികളും നിങ്ങളുടെ പക്കൽ ഉണ്ടോ?",
      answer: "അതെ, DTP-യിൽ നിന്നുള്ള ലേഔട്ട് പർമിറ്റ്, പഞ്ചായത്തിൽ നിന്നുള്ള ഡെവലപ്മെന്റ് പർമിറ്റ് എന്നിവ ഞങ്ങളുടെ പക്കലുണ്ട്. പദ്ധതി K RERA-യിൽ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.",
      category: "legal",
      icon: Shield
    },
    {
      question: "എന്റെ താമസത്തിൽ ആവർത്തിച്ചുള്ള ചെലവുകൾ ഉണ്ടാകുമോ?",
      answer: "ഓരോ വില്ലയ്ക്കും പ്രതിമാസ പരിപാലന ചെലവുകൾ ബാധകമായിരിക്കും. മൊത്തം ചെലവുകൾ വില്ലയുടെ നിർമ്മിത വിസ്തീർണ്ണത്തിന് ആനുപാതികമായി പങ്കിടും.",
      category: "pricing",
      icon: Home
    },
    {
      question: "പ്രതിമാസ പരിപാലന ചാർജിൽ എന്തൊക്കെ ഉൾപ്പെടുന്നു?",
      answer: "സാധാരണ വൈദ്യുതി ബില്ലുകൾ, ജീവനക്കാരുടെ ശമ്പളം, പദ്ധതിയുടെ പൊതു പ്രദേശത്തിന്റെയും ഉപകരണങ്ങളുടെയും പരിപാലന ചെലവുകൾ, ബാധകമായ നികുതികൾ, ഉപഭോഗവസ്തുക്കൾ, ലാൻഡ്സ്കേപ്പിംഗ്, നീന്തൽക്കുളം തുടങ്ങിയവ.",
      category: "services",
      icon: Heart
    },
    {
      question: "ദമ്പതികൾക്ക് ഒരുമിച്ച് താമസിക്കാൻ കഴിയുമോ?",
      answer: "അതെ, തീർച്ചയായും. വില്ല നിങ്ങളുടേതാണ്, അത് നിങ്ങളുടെ സ്വകാര്യ സ്വത്താണ്.",
      category: "living",
      icon: Heart
    },
    {
      question: "മെഡിക്കൽ അപ്പോയിന്റ്മെന്റുകൾക്കുള്ള ഗതാഗത സൗകര്യം നിങ്ങൾ നൽകുന്നുണ്ടോ?",
      answer: "അടിയന്തിര സാഹചര്യത്തിൽ, താമസക്കാരനെ ആശുപത്രിയിൽ എത്തിക്കുന്നു, ചെലവ് അവരുടെ അക്കൗണ്ടിൽ നിന്ന് ഈടാക്കും.",
      category: "services",
      icon: Shield
    },
    {
      question: "താമസത്തിന് വരാനുള്ള പ്രക്രിയ എങ്ങനെയാണ്?",
      answer: "വില്ലയും പദ്ധതിയും തയ്യാറായി OC ലഭിച്ചുകഴിഞ്ഞാൽ, വില്ല അതത് ഉടമകൾക്ക് ഔദ്യോഗികമായി കൈമാറുന്നു. അവർക്ക് എപ്പോൾ വേണമെങ്കിലും അവരുടെ വില്ലകളിൽ താമസിക്കാം. OC ലഭിക്കുന്ന സമയത്ത് പൊതു സൗകര്യങ്ങളും സേവനങ്ങളും സജ്ജമായിരിക്കും.",
      category: "timeline",
      icon: Home
    },
    {
      question: "സൗകര്യങ്ങൾക്ക് ചാർജ് ഉണ്ടോ?",
      answer: "പൊതു സൗകര്യങ്ങളുടെ പരിപാലന ചെലവ് പ്രതിമാസ പരിപാലന ചാർജിൽ ഉൾപ്പെടുത്തിയിട്ടുണ്ട്, അതിനാൽ അവയ്ക്ക് ചാർജ് ഇല്ല. അലക്കുപണി, ഭക്ഷണം, വെൽനെസ് സെന്റർ ഉപയോഗം തുടങ്ങിയ ചെലവുകൾ യഥാർത്ഥ ഉപയോഗത്തിന് ആനുപാതികമായി ഈടാക്കുന്നു. മെഡിക്കൽ ചെലവുകൾ, കാറിന്റെയും ഡ്രൈവറുടെയും ഉപയോഗവും യഥാർത്ഥ ഉപയോഗത്തിന് അനുസരിച്ച് ഈടാക്കുന്നു.",
      category: "services",
      icon: Star
    },
    {
      question: "ഡൈനിംഗ് ഹാളിൽ നിന്ന് ഭക്ഷണം കഴിക്കുന്നത് നിർബന്ധമാണോ?",
      answer: "ഇല്ല. താമസക്കാർക്ക് കഴിയുമെങ്കിൽ സ്വന്തമായി ഭക്ഷണം പാകം ചെയ്യാൻ പ്രോത്സാഹിപ്പിക്കുന്നു. റെസ്റ്റോറന്റ് സൗകര്യങ്ങൾ എല്ലാ ഭക്ഷണത്തിനും ലഘുഭക്ഷണത്തിനും തുറന്നിരിക്കുന്നു. ഇത് ഓപ്ഷണലാണ്.",
      category: "living",
      icon: Heart
    },
    {
      question: "എനിക്ക് എന്റെ വില്ലയിൽ തന്നെ പാചകം ചെയ്യാൻ കഴിയുമോ?",
      answer: "അതെ. താമസക്കാർക്ക് വില്ലയിൽ തന്നെ അവരുടെ ഭക്ഷണം പാകം ചെയ്യാം.",
      category: "living",
      icon: Home
    },
    {
      question: "ഞാൻ താമസിക്കാത്ത സമയത്ത് എന്റെ വില്ല വാടകയ്ക്ക് നൽകാമോ?",
      answer: "നിങ്ങൾ വില്ലയിൽ താമസിക്കുന്നില്ലെങ്കിൽ, അത് വാടകയ്ക്ക് നൽകാം. ആവശ്യമെങ്കിൽ നിങ്ങളുടെ വില്ല വാടകയ്ക്ക് നൽകുന്നതിൽ ഞങ്ങൾ സഹായിക്കുന്നു.",
      category: "legal",
      icon: Shield
    },
    {
      question: "വില്ല എന്റെ പേരിൽ രജിസ്റ്റർ ചെയ്യുമോ?",
      answer: "അതെ, വില്ല അതത് ഉടമകളുടെ പേരിൽ അനുബന്ധ ഭൂവിസ്തീർണ്ണത്തോടുകൂടി രജിസ്റ്റർ ചെയ്യുന്നു.",
      category: "legal",
      icon: Shield
    },
    {
      question: "ഭാവിയിൽ എന്റെ വില്ല വിൽക്കാമോ, അതിന് നിങ്ങൾ സഹായിക്കുമോ?",
      answer: "വില്ലയിൽ നിങ്ങൾക്ക് ഫ്രീഹോൾഡ് അവകാശം ഉള്ളതിനാൽ, അത് വിൽക്കാനോ മറ്റൊരാൾക്ക് കൈമാറാനോ കഴിയും. നിങ്ങളുടെ വില്ല വിൽക്കുന്നതിൽ ഞങ്ങൾ സഹായിക്കുന്നു.",
      category: "legal",
      icon: Home
    }
  ]
};

export const categories = [
  { key: 'all', label: 'All', icon: 'HelpCircle' },
  { key: 'pricing', label: 'Pricing', icon: 'Home' },
  { key: 'services', label: 'Services', icon: 'Heart' },
  { key: 'living', label: 'Living', icon: 'Star' },
  { key: 'legal', label: 'Legal', icon: 'Shield' },
  { key: 'timeline', label: 'Timeline', icon: 'Star' }
];